/**
 * We want to ignore updates for boards if we have pending patches. That would lead to changes
 * made by the user to be (temporarily) overwritten. This is known as "zipzap" and bothered us
 * for quite a while.
 */
import type {PatchPublished, PublishPatch, SyncUpdate} from "@cling/lib.web.worker/worker_interface"
import type {EventBus} from "@cling/lib.web.primitives"
import {BoardUID, PatchUID, is_BoardUID} from "@cling/lib.shared.model"

export function init(publish_patch_bus: EventBus<PublishPatch | PatchPublished>) {
    const pending_patches = new Map<PatchUID, BoardUID[]>()
    publish_patch_bus.addEventListener((event) => {
        const msg = event.data
        if (msg.type === "patch_published") {
            pending_patches.delete(msg.patch_uid)
        }
    })
    return {
        ignore_sync_update: (msg: SyncUpdate) => {
            if (msg.type === "sync_put" && is_BoardUID(msg.uid)) {
                const board_uid = msg.uid
                return [...pending_patches.values()].some((x) => x.includes(board_uid))
            }
            return false
        },
        publish_patch: ({
            board_uids,
            patch_pb,
            patch_uid,
            transformed_patches_pb,
        }: {
            patch_uid: PatchUID
            board_uids: BoardUID[]
            patch_pb: Uint8Array
            transformed_patches_pb: Uint8Array[]
        }) => {
            pending_patches.set(patch_uid, board_uids)
            publish_patch_bus.postMessage({type: "publish_patch", patch_pb, transformed_patches_pb})
        },
    }
}
